module.exports = __webpack_public_path__ + "static/media/HistorialNoDisponibleHeader.4f6b5f41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/NoAvailable/HistorialNoDisponibleHeader.svg
// module id = 1817
// module chunks = 0